const declOfNum = (counter: number, texts: [string, string, string]): string => {
  const n = Math.abs(counter) % 100;
  const n1 = n % 10;

  if (n > 10 && n < 20) {
    return texts[2];
  }
  if (n1 > 1 && n1 < 5) {
    return texts[1];
  }
  if (n1 == 1) {
    return texts[0];
  }

  return texts[2];
};

export default declOfNum;
